import { FormikProps, useFormik } from 'formik';
import React from 'react';
import { Button, Dialog, Grid } from 'src/components';
import DialogActions from 'src/components/DialogActions';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import NumberField from 'src/components/NumberField';
import { translate } from 'src/i18n/tHelper';
import VwKurumbonustanimtestveriDTO from 'src/models/KurumBonusTanim/VwKurumbonustanimtestveriDTO';
import { useKurumBonusTanimTestVeriEkleMutation, useKurumBonusTanimTestVeriGuncelleMutation } from 'src/services/KurumBonusTanimlari/KurumBonusTanimlariApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import { kurumBonusTanimlariTestVeVeriyeGoreSlice } from 'src/store/Slices/KurumBonusTanimlari/KurumBonusTanimlariTestVeVeriyeGoreSlice';
import TestDetayBilgiAutocomplete from 'src/parts/TestDetayBilgi/TestDetayBilgiAutocomplete';
import * as yup from 'yup';

const translatePath = "pages|kurumBonusTanimlari";
let formik: FormikProps<VwKurumbonustanimtestveriDTO> = null;
const KurumBonusTanimlariTestVeVeriyeGoreListeEkle = (): JSX.Element => {
    const state = useAppSelector(s => s.kurumBonusTanimlariTestVeVeriyeGore);
    const kurumBonusTanimlariTestBazliState = useAppSelector(s => s.kurumBonusTanimlariTestBazli);
    const dispatch = useAppDispatch();

    const [ekle, ekleState] = useKurumBonusTanimTestVeriEkleMutation();
    const [guncelle, guncelleState] = useKurumBonusTanimTestVeriGuncelleMutation();

    const handlerSave = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (!ekleState.isLoading && !guncelleState.isLoading)
            formik.submitForm();
    }
    const handlerClose = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(kurumBonusTanimlariTestVeVeriyeGoreSlice.actions.setOpen(false));
    };

    formik = useFormik({
        enableReinitialize: true,
        initialValues: state.activeRow,
        validateOnChange: false,
        onSubmit: async (values) => {
            if (!kurumBonusTanimlariTestBazliState.activeRow.id) return;
            if (values?.id > 0) {
                await guncelle(values).unwrap().then(() => { handlerClose(null); }).catch(e => e);
                return;
            }
            await ekle(values).unwrap().then(() => { handlerClose(null); }).catch(e => e);
        },
        validationSchema: yup.object().shape({
            fkTestDetaybilgiId: yup.number().required(translate(translatePath, "Test Detay Bilgi alanı zorunludur")),
            veriAralikBaslangic: yup.number()
                .required(translate(translatePath, "Veri Aralık Başlangıç alanı zorunludur"))
                .test('max', translate(translatePath, "Başlangıç değeri bitiş değerinden büyük olamaz"), function(value) {
                    const { veriAralikBitis } = this.parent;
                    if (!value || !veriAralikBitis) return true;
                    return value <= veriAralikBitis;
                }),
            veriAralikBitis: yup.number()
                .required(translate(translatePath, "Veri Aralık Bitiş alanı zorunludur"))
                .test('min', translate(translatePath, "Bitiş değeri başlangıç değerinden küçük olamaz"), function(value) {
                    const { veriAralikBaslangic } = this.parent;
                    if (!value || !veriAralikBaslangic) return true;
                    return value >= veriAralikBaslangic;
                })
        }),
    });


    return (
        <Dialog fullWidth open={state.open} maxWidth="sm">
            <DialogTitle>{translate(translatePath, "Kurum Bonus Tanımı Ekle")}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item>
                        <TestDetayBilgiAutocomplete
                            required={true}
                            aktifGoster={true}
                            islemTanimId={kurumBonusTanimlariTestBazliState.activeRow?.fkIslemtanimId}
                            label="Test Detay Bilgi"
                            name="fkTestDetaybilgiId"
                            value={formik.values.fkTestDetaybilgiId}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.fkTestDetaybilgiId)}
                            helperText={formik.errors.fkTestDetaybilgiId}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <NumberField
                            required
                            allowNegative={false}
                            label={translate(translatePath, "Veri Aralık Başlangıç")}
                            name="veriAralikBaslangic"
                            value={formik.values.veriAralikBaslangic}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.veriAralikBaslangic)}
                            helperText={formik.errors.veriAralikBaslangic}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <NumberField
                            required
                            allowNegative={false}
                            label={translate(translatePath, "Veri Aralık Bitiş")}
                            name="veriAralikBitis"
                            value={formik.values.veriAralikBitis}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.veriAralikBitis)}
                            helperText={formik.errors.veriAralikBitis}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={!formik.dirty} loading={ekleState.isLoading || guncelleState.isLoading} customType="save" onClick={handlerSave} />
                <Button customType="close" onClick={handlerClose} />
            </DialogActions>
        </Dialog>
    );
};

export default KurumBonusTanimlariTestVeVeriyeGoreListeEkle;